import React from 'react';
import './header.css'

export default function Header() {
   
    return (
        <div className='text-center' id='header-wrapper'>
            <h3 className='fs-1'>Joe Trello ❤️</h3>
            <h6 className='fs-4'>Manage your software/App life cycle(Drag and Drop method) </h6>
            <div id="" className="form-text text-danger">You can use this app/softaware to manage your business and daily-to-day activities.</div>
        </div>
    )
}
